<template>
  <v-app style="background-image: #fff">
    <v-card elevation="1" class="custom-card">
      <v-flex class="text-xs-center display-1 px-5 pt-5 pb-2 red--text">
        404 error, page not found
      </v-flex>
      <v-flex class="text-xs-center title px-5 pb-5 pt-2">
        Somethings went wrong, please check again.
      </v-flex>
    </v-card>
  </v-app>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
